// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/TrackingKindService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { TrackingKindCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { TrackingKindDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { TrackingKindFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/TrackingKindService.proto.
 */
export const file_Services_TrackingKindService: GenFile = /*@__PURE__*/
  fileDesc("CiJTZXJ2aWNlcy9UcmFja2luZ0tpbmRTZXJ2aWNlLnByb3RvMtQDChNUcmFja2luZ0tpbmRTZXJ2aWNlEvwBCg9HZXRUcmFja2luZ0tpbmQSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjgudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5UcmFja2luZ0tpbmREZXRhaWxlZER0byJvoNrNDwGC0+STAmRaJjoBKiIhL2FwaS90cmFja2luZ0tpbmQvZ2V0VHJhY2tpbmdLaW5kEjovYXBpL3RyYWNraW5nS2luZC9nZXRUcmFja2luZ0tpbmQve2lkLmhpZ2hfNjR9L3tpZC5sb3dfNjR9Er0BChBHZXRUcmFja2luZ0tpbmRzEjYudGltZV90cmFja2luZy5tZXNzYWdlcy5maWx0ZXJzLlRyYWNraW5nS2luZEZpbHRlcnNEdG8aPS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbGxlY3Rpb25zLlRyYWNraW5nS2luZENvbGxlY3Rpb25EdG8iMqDazQ8BgtPkkwInOgEqIiIvYXBpL3RyYWNraW5nS2luZC9nZXRUcmFja2luZ0tpbmRzQiSqAiFNb2dpLlRpbWVUcmFja2luZy5Db21tb24uU2VydmljZXNiBnByb3RvMw", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * Read operations for tracking kinds (billable, etc.).
 *
 * @generated from service TrackingKindService
 */
export const TrackingKindService: GenService<{
  /**
   * Fetch a tracking kind (billable, etc.) specified by its id.
   *
   * @generated from rpc TrackingKindService.GetTrackingKind
   */
  getTrackingKind: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof TrackingKindDetailedDtoSchema;
  },
  /**
   * Fetch tracking kinds (billable, etc.) according to filters.
   *
   * @generated from rpc TrackingKindService.GetTrackingKinds
   */
  getTrackingKinds: {
    methodKind: "unary";
    input: typeof TrackingKindFiltersDtoSchema;
    output: typeof TrackingKindCollectionDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_TrackingKindService, 0);

